<ng-container *ngIf="bigProgress; then progressBig else progress"></ng-container>

<ng-template #progress>
  <div class="progress-bar-container">
    <div class="caption">
      <ng-content></ng-content>
      <span *ngIf="showPercentageNumber" class="tw-font-semibold">{{ width }}%</span>
    </div>
    <div class="progress">
      <div class="progress-bar" [ngClass]="{'tw-bg-sbBlue-500' : !classes}" [class]="classes" [style.width.%]="width"></div>
    </div>
  </div>
</ng-template>

<ng-template #progressBig>
  <div class="progress-bar-container progress-big">
    <div class="caption">
    </div>
    <div class="tw-flex tw-justify-between">
      <div class="progress">
        <div class="progress-bar" [ngClass]="{'tw-bg-sbBlue-500' : !classes}" [class]="classes" [style.width.%]="width"></div>
      </div>
      <span class="tw-pl-3 percentValue"><strong>{{ width }}%</strong></span>
    </div>
  </div>

</ng-template>
